import {
  Alert,
  Box,
  CircularProgress,
  Grid2,
  Typography
} from '@mui/material';
import { useSchoolClass } from 'pages/SchoolClass/hooks/useSchoolClass';
import { ClassCriticalStudents } from './ClassCriticalStudents';
import { ClassAlertsList } from './ClassAlertsList';
import { ClassFrequencyChart } from './ClassFrequencyChart';
import { ClassHourlyPeaks } from './ClassHourlyPeaks';
import { ClassKpiCards } from './ClassKpiCards';
import { ClassNotificationStats } from './ClassNotificationStats';

type SchoolClassHookReturn = ReturnType<typeof useSchoolClass>;

interface ClassDashboardTabProps {
  state: SchoolClassHookReturn['state'];
}

export function ClassDashboardTab({ state }: ClassDashboardTabProps) {
  const { dashboardData, isFetchingDashboard, selectedId } = state;

  if (selectedId === 'new' || selectedId === 'all') {
    return (
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', p: 10 }}>
        <Typography color="text.secondary">Selecione uma turma para visualizar o dashboard.</Typography>
      </Box>
    );
  }

  if (isFetchingDashboard) {
    return (
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', p: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!dashboardData) {
    return (
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', p: 5 }}>
        <Alert severity="info">Não há dados suficientes para exibir o dashboard desta turma.</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3, flex: 1 }}>
      
      {/* 1. TOPO: KPI CARDS */}
      <ClassKpiCards kpis={dashboardData.kpis} />

      {/* 2. MEIO: GRÁFICOS */}
      <Grid2 container spacing={3} alignItems="stretch">
        <Grid2 size={{ xs: 12, lg: 8 }}>
          <ClassFrequencyChart data={dashboardData.frequencyHistory} />
        </Grid2>
        
        <Grid2 size={{ xs: 12, lg: 4 }}>
          <ClassHourlyPeaks data={dashboardData.hourlyPeaks} />
        </Grid2>
      </Grid2>

      {/* 3. RODAPÉ: ALERTAS E LISTAS */}
      <Grid2 container spacing={3} alignItems="stretch">
        <Grid2 size={{ xs: 12, md: 4 }}>
          <ClassAlertsList alerts={dashboardData.alerts} />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 4 }}>
          <ClassNotificationStats stats={dashboardData?.notificationStats} />
        </Grid2>

        <Grid2 size={{ xs: 12, md: 4 }}>
          <ClassCriticalStudents students={dashboardData.criticalStudents} />
        </Grid2>
      </Grid2>
      
    </Box>
  );
}